<template>
  <section>
    <div class="container">
      <div class="has-text-right mb-1">
        <b-button class="is-primary is-outlined"
                  icon-left="plus"
                  v-if="can_create_study==='true'"
                  @click="isAddModalActive = true">
          Añadir Estudio
        </b-button>
      </div>

      <!--DATA TABLE-->
      <b-table
          :data="person_studies"
          :paginated= true
          per-page="10"
          striped
          hoverable
          :current-page="currentPage"
          :pagination-simple=false
          pagination-position="bottom"
          default-sort-direction="asc"
          sort-icon="arrow-up"
          sort-icon-size="is-small"
          default-sort="product.title"
          aria-next-label="Siguiente"
          aria-previous-label="Anterior"
          aria-page-label="Página"
          aria-current-label="Página actual">
        <b-table-column
            field="egress_date"
            label="Fecha obtención"
            width="110"
            sortable
            searchable :custom-search="searchEgressDate">
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{props.row.egress_date._isValid ? new Date(props.row.egress_date).toLocaleDateString("es-CL") : ''}}
          </template>
        </b-table-column>
        <b-table-column
            field="study.study_type"
            label="Tipo Estudio"
            sortable
            searchable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{props.row.study!==undefined ? props.row.study.study_type : ""}}
          </template>
        </b-table-column>
        <b-table-column
            field="study.name"
            label="Nombre Estudio"
            sortable
            searchable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{props.row.study!==undefined ? props.row.study.name : ""}}
          </template>
        </b-table-column>
        <b-table-column
            field="study.entity_show_name"
            label="Institución"
            sortable
            searchable>
          <template
              slot="searchable"
              slot-scope="props">
            <b-input
                v-model="props.filters[props.column.field]"
                icon="search"
                size="is-small" />
          </template>
          <template v-slot="props">
            {{props.row.entity_show_name}}
          </template>
        </b-table-column>
        <b-table-column
            label="Acciones"
            width="125"
            v-slot="props">

          <b-tooltip
              v-if="props.row.can_show"
              label="Ver información completa del estudio."
              position="is-left"
              :active="true">
            <b-button
                pack="fas"
                icon-left="eye"
                type="is-primary"
                @click="execShowModal(props.row.id)"/>
          </b-tooltip>


          <b-tooltip
              v-if="props.row.can_edit"
              label="Editar información del estudio."
              position="is-left"
              :active="true">
            <b-button
                pack="fas"
                icon-left="edit"
                type="is-info is-light is-outlined"
                @click="execEditModal(props.row.id)"/>
          </b-tooltip>

          <b-tooltip
              v-if="props.row.can_nullify"
              label="Anular estudio."
              position="is-left"
              :active="true">
            <b-button
                pack="fas"
                icon-left="trash"
                type="is-danger is-light is-outlined"
                @click="execNullifyModal(props.row.id)"/>
          </b-tooltip>

          <b-tooltip
              v-if="props.row.can_view_pdf"
              label="Visualizar documento asociado al estudio."
              position="is-left"
              :active="true">
            <b-button
                pack="fas"
                icon-left="file-alt"
                type="is-success is-light is-outlined"
                @click="viewFile(props.row.document_id)"/>
          </b-tooltip>

          <b-tooltip
              v-if="props.row.can_view_pdf"
              label="Descargar documento asociado al estudio."
              position="is-left"
              :active="true">
            <b-button
                pack="fas"
                icon-left="download"
                type="is-primary is-light is-outlined"
                @click="downloadFile(props.row.document_id)"/>
          </b-tooltip>

        </b-table-column>
      </b-table>
      <!--FIN DATA TABLE-->
      <!-- MODALES -->
      <b-modal
          v-model="isAddModalActive"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal
          :can-cancel="canCancel">
        <template #default="props">
          <study-form :person-id="personId"
                            query-type="create"
                            :modal-header="'Nuevo Estudio - '  +person_name"
                            @close="props.close"></study-form>
        </template>
      </b-modal>
      <b-modal
          v-model="isShowModalActive"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal>
        <template #default="props">
          <study :id="selected"
                       :modal-header="'Estudio - '  +person_name"
                       :person_name="person_name"
                       @close="props.close">
          </study>
        </template>
      </b-modal>
      <b-modal
          v-model="isEditModalActive"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal
          :can-cancel="canCancel"
          width="90%">
        <template #default="props">
          <study-form :person-id="personId"
                            :id="selected"
                            query-type="update"
                           :modal-header="'Editar Estudio - '  +person_name"
                            @close="props.close">
          </study-form>
        </template>
      </b-modal>
      <b-modal
          v-model="showPdf"
          :can-cancel="true"
          :destroy-on-hide="true"
          aria-modal
          aria-role="dialog"
          has-modal-card
          trap-focus
          :width="2000"
      >
        <template #default="props">
          <pdf_view
              :src="src"
              @close="props.close"
          ></pdf_view>
        </template>

      </b-modal>
    <b-loading :is-full-page="true"
               v-model="isLoading"
               :can-cancel="false"/>
    </div>
  </section>
</template>

<script>
import Study from "./study.vue";
import StudyForm from "./modal_study_form.vue";
import axios from "axios";
import {searchDate, formatDate} from "../../packs/utilities";
import moment from "moment";
import Pdf_view from "../performances/pdf_view.vue";
export default {
  name: "studies",
  props:[
    'personId', 'can_create_study', 'person_name'
  ],
  components:{
    Pdf_view,
    Study,
    StudyForm
  },
  data(){
    return {
      selected: null,
      index: null,
      canCancel: [],
      currentPage: 1,
      isAddModalActive: false,
      isEditModalActive: false,
      isShowModalActive: false,
      isLoading:false,
      person_studies: [],
      isNullifyActive: false,
      showPdf: false,
      src:null,
    }
  },
  created(){
    this.initialize()
  },
  methods:{
    execNullifyModal(id){
      this.$buefy.dialog.confirm({
        title: 'Anular estudio',
        message: '¿Está seguro que desea <b>anular</b> el estudio? Esta acción lo dejará inválido.<br>',
        confirmText: 'Anular Estudio',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.isNullifyActive = true
          this.isLoading = true
          axios
              .delete("/admin/person_studies/" + id + "/nullify_study.json")
              .then(res => {
                this.$buefy.dialog.alert({
                  message: 'Estudio anulado correctamente',
                  duration: 5000,
                  type: 'is-success',
                  canCancel: ["escape", "outside"]
                })
                this.isLoading = false;
                this.isNullifyActive = false;
              }).catch(error => {
            console.log(error)
            this.$buefy.dialog.alert({
              message: '<b>Estudio no pudo ser anulado</b><br>',
              duration: 5000,
              type: 'is-damger',
              canCancel: ["escape", "outside"]
            })
            this.isLoading = false;
            this.isNullifyActive = false;
          })
        }
      })
    },
    initialize(){
      console.log("CAN CREATE STUDY: ", this.can_create_study)
      this.isLoading = true;
      return axios
          .get("/people/"+this.personId+"/studies.json")
          .then(res => {
            this.person_studies = res.data
            this.person_studies = this.person_studies.map(study => {
              var newStudy = study
              newStudy["egress_date"] = moment(newStudy["egress_date"], ["YYYY-MM-DD","DD-MM-YYYY"]);
              return newStudy;
            });
            this.isLoading=false;
          }).catch(error => {
            console.log(error)
            this.isLoading=false;
          })

    },
    execShowModal(id){
      this.selected = id;
      this.isShowModalActive = true;
    },
    execEditModal(id){
      this.selected = id;
      this.isEditModalActive = true;
    },
    // yyyy/mm/dd -> dd/mm/yyyy
    formatDate,
    searchEgressDate(row, input){
      return searchDate(row.egress_date, input)
    },
    viewFile(fileId){
      this.isLoading = true;
      axios
          .get("/documents/" + fileId + "/download", {
            responseType: "blob",
            params:{
              life_record: true
            }
          })
          .then(async res => {
            const file = new File([new Blob([res.data])], "test");
            const buffer = await file.arrayBuffer();
            this.src = new Uint8Array(buffer);
            this.showPdf = true
            this.isLoading = false
          })
          .catch(e => {
            console.log(e)
            this.isLoading = false
            this.$buefy.dialog.alert({
              message: "ERROR al previsualizar",
              type: "is-danger",
              hasIcon: true
            })
          })

    },
    downloadFile(fileId){
      this.isLoading = true;

      if (fileId == null){
        this.isLoading = false;
        return;
      }

      axios
          .get("/documents/" + fileId + "/download", {
            responseType: "blob",
            params:{
              life_record: true
            }
          })
          .then(res => {
            let blob = new Blob([res.data], {
              type: "application/pdf",
            })
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = res.headers["content-disposition"]
                .split(";")[1]
                .split('"')[1];
            link.click();
            this.isLoading=false
            this.$buefy.notification.open({
              message: 'El documento fue descargado con exito',
              type: 'is-success',
              hasIcon: true,
              position: 'is-bottom-right',
              duration: 5000,
              progressBar: true,
            })
          })
          .catch(e => {
            console.log(e)
            this.isLoading=false
            this.$buefy.notification.open({
              message: 'El documento no se pudo descargar',
              type: 'is-danger',
              hasIcon: true,
              position: 'is-bottom-right',
              duration: 5000,
              progressBar: true,
            })
          })
    },

  },
  watch:{
    isNullifyActive: function () {
      if (!this.isNullifyActive){
        this.initialize()
      }
    },
    isAddModalActive: function () {
      if (!this.isAddModalActive) {
        this.initialize()
      }
    },
    isEditModalActive: function () {
      if (!this.isEditModalActive) {
        this.initialize()
      }
    },
    isShowModalActive: function () {
      if (!this.isShowModalActive) {
        this.initialize()
      }
    },

  }
}
</script>

<style scoped>

</style>